import { ref, onUnmounted, computed } from '@vue/composition-api'

function getCountDown(extraTime = 0) {
  // 显示时长为生产平台实际配置时长单位秒+2s反馈时长
  const realCountdown = ref(null)
  // 没有添加额外时长的倒计时
  const countdown = computed(() => {
    if (!realCountdown.value) {
      return 0
    }
    const val = realCountdown.value - extraTime
    return val > 0 ? val : 0
  })
  const extraCountdown = computed(() => {
    if (!realCountdown.value) {
      return 0
    }
    const val = extraTime - realCountdown.value
    return val > 0 ? val : 0
  })
  let timeoutId = null
  /**
   *
   * @param {*} duration
   * @param {*} realEnd 真正的倒计时结束，包含额外添加到时长
   * @param {*} extraTime 在原有的倒计时上额外添加的时长，默认 0
   * @param {*} end 倒计时结束，不包含额外添加的时长
   */
  function start(duration = 0, realEnd, end = () => {}) {
    realCountdown.value = duration + extraTime
    function countFun() {
      timeoutId = setTimeout(() => {
        realCountdown.value--
        if (realCountdown.value - extraTime === 0) {
          // 倒计时结束
          end()
        }
        if (realCountdown.value === 0) {
          // 真正的倒计时结束，包含额外添加到时长
          realEnd()
          return
        }
        countFun()
      }, 1000)
    }
    countFun()
  }

  // 组件卸载时清除倒计时
  onUnmounted(() => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
  })
  return {
    realCountdown,
    countdown,
    extraCountdown,
    start
  }
}

export default getCountDown
